import React from 'react'

export const ErrorPage = () => {

  return (

    <div id="main">
      <div class="fof">
        <h1>Error 404</h1>
      </div>
    </div>
  )
}
